// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-label[data-v-403a99cf] {\n  font-size: 0.675rem;\n}\n.silence-banner[data-v-403a99cf] {\n  background-color: #FFFDEC;\n  border-radius: 7px;\n}\n.silence-banner .v-icon[data-v-403a99cf] {\n  color: #a3bac0;\n}", ""]);
// Exports
module.exports = exports;
